import React from 'react';
import { Card, CardContent, CardHeader, Stack, TextField, Button, MenuItem, InputLabel, FormControl } from '@mui/material';


const BaseDataForm = ({ formik }) => (
  <Stack flexDirection="row" justifyContent="space-between">
    <Card sx={{ flexGrow: 0.48 }}>
      <CardHeader title="Sprzedający" />
      <CardContent>
        <Stack spacing={2}>
          <TextField
            id="seller_company_name"
            size="small"
            label="Nazwa firmy"
            value={formik.values.seller_company_name}
            onChange={formik.handleChange}
            error={formik.errors.seller_company_name && formik.touched.seller_company_name}
            helperText={formik.errors.seller_company_name}
          ></TextField>
          <TextField id="seller_name" size="small" label="Imię i nazwisko" value={formik.values.seller_name} onChange={formik.handleChange}></TextField>
          <TextField
            id="seller_street_address"
            size="small"
            label="Ulica i numer"
            value={formik.values.seller_street_address}
            onChange={formik.handleChange}
            error={formik.errors.seller_street_address && formik.touched.seller_street_address}
            helperText={formik.errors.seller_street_address}
          ></TextField>
          <TextField
            id="seller_postal_code"
            size="small"
            label="Kod pocztowy"
            value={formik.values.seller_postal_code}
            onChange={formik.handleChange}
            error={formik.errors.seller_postal_code && formik.touched.seller_postal_code}
            helperText={formik.errors.seller_postal_code}
          ></TextField>
          <TextField
            id="seller_city"
            size="small"
            label="Miasto"
            value={formik.values.seller_city}
            onChange={formik.handleChange}
            error={formik.errors.seller_city && formik.touched.seller_city}
            helperText={formik.errors.seller_city}
          ></TextField>
          <TextField id="seller_nip" size="small" label="NIP" value={formik.values.seller_nip} onChange={formik.handleChange}></TextField>
          <TextField
            id="bank_name"
            size="small"
            label="Nazwa banku"
            value={formik.values.bank_name}
            onChange={formik.handleChange}
          ></TextField>
          <TextField
            id="account_number"
            size="small"
            label="Numer konta"
            value={formik.values.account_number}
            onChange={formik.handleChange}
          ></TextField>
        </Stack>
      </CardContent>
    </Card>
    <Card sx={{ flexGrow: 0.48 }}>
      <CardHeader title="Kupujący" />
      <CardContent>
        <Stack spacing={2}>
          <TextField
            id="buyer_name"
            size="small"
            label="Imię i nazwisko"
            value={formik.values.buyer_name}
            onChange={formik.handleChange}
            error={formik.errors.buyer_name && formik.touched.buyer_name}
            helperText={formik.errors.buyer_name}
          ></TextField>
          <TextField
            id="buyer_street_address"
            size="small"
            label="Uilca i numer"
            value={formik.values.buyer_street_address}
            onChange={formik.handleChange}
            error={formik.errors.buyer_street_address && formik.touched.buyer_street_address}
            helperText={formik.errors.buyer_street_address}
          ></TextField>
          <TextField
            id="buyer_postal_code"
            size="small"
            label="Kod pocztowy"
            value={formik.values.buyer_postal_code}
            onChange={formik.handleChange}
            error={formik.errors.buyer_postal_code && formik.touched.buyer_postal_code}
            helperText={formik.errors.buyer_postal_code}
          ></TextField>
          <TextField
            id="buyer_city"
            size="small"
            label="Miasto"
            value={formik.values.buyer_city}
            onChange={formik.handleChange}
            error={formik.errors.buyer_city && formik.touched.buyer_city}
            helperText={formik.errors.buyer_city}
          ></TextField>
          <TextField id="buyer_nip" size="small" label="NIP" value={formik.values.buyer_nip} onChange={formik.handleChange}></TextField>
        </Stack>
      </CardContent>
    </Card>
  </Stack>
);

export default BaseDataForm;
